<div class="flex-column flex-fill flex-100">
  <kendo-grid #grid style="font-size:12px; height:100%;"
    [data]="view | async"
    [pageSize]="state.take"
    [resizable]="true"
    [skip]="state.skip"
    [sort]="state.sort"
    [sortable]="{mode: 'multiple'}"
    [pageable]="true"
    [scrollable]="'scrollable'"
    [filter]="state.filter"
    (dataStateChange)="dataStateChange($event)"
    (selectionChange)="selectionChange($event)"
    (dblclick)="onGridDblClick($event)"
    (cellClick)="onGridCellClick($event)"
    [filterable]="true"
    [navigable]="true" [reorderable]="true"
    [kendoGridSelectBy]="'ProjectId'" [selectedKeys]="selectedProjectKeys">

    <kendo-grid-checkbox-column [reorderable]="false" [width]="40" [showSelectAll]="true" [locked]="true"></kendo-grid-checkbox-column>

    @for (col of columns(); track col) {
      @if (col.params.skip) {
        @switch (col.field) {
          @case ('AfeNumber') {
            <kendo-grid-column field="AfeNumber" title="WBS Number" [width]="col.params.width" [hidden]="col.params.hide" [locked]="col.params.lock">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span (click)="onRowClick($event,dataItem,rowIndex)" style="cursor:pointer">
                  {{dataItem.AfeNumber}}
                </span>
              </ng-template>
            </kendo-grid-column>
          }
          @case ('WBSType') {
            <kendo-grid-column field="WBSType" title="WBS Type" [width]="col.params.width" [hidden]="col.params.hide" [locked]="col.params.lock">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                {{dataItem.WBSType}}
              </ng-template>
            </kendo-grid-column>
          }
          @case ('WBSSubType') {
            <kendo-grid-column field="WBSSubType" title="WBS Sub Type" [width]="col.params.width" [hidden]="col.params.hide" [locked]="col.params.lock">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                {{dataItem.WBSSubType}}
              </ng-template>
            </kendo-grid-column>
          }
          @case ('ProjectId') {
            <kendo-grid-column field="ProjectId" title="Project ID" [width]="col.params.width" [hidden]="col.params.hide" [locked]="col.params.lock">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-numeric-filter-cell
                  [column]="column"
                  [filter]="filter"
                  [format]="'####'"
                  [showOperators]="false"
                  [spinners]="false">
                </kendo-grid-numeric-filter-cell>
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span (click)="onRowClick($event,dataItem,rowIndex)" style="cursor:pointer">
                  {{dataItem.ProjectId | kendoNumber:'000000'}}
                </span>
              </ng-template>
            </kendo-grid-column>
          }
          @case ('Name') {
            <kendo-grid-column field="Name" title="Project Name" [width]="col.params.width" [hidden]="col.params.hide" [locked]="col.params.lock">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span (click)="onRowClick($event,dataItem,rowIndex)" style="cursor:pointer">
                  {{dataItem.Name}}
                </span>
              </ng-template>
            </kendo-grid-column>
          }
          @case ('StartDate') {
            <kendo-grid-column field="StartDate" title="Project Start" [width]="col.params.width" [filterable]="col.params.filterable" [hidden]="col.params.hide" [locked]="col.params.lock" filter="date">
              @if (col.displayField == null; as dataItem) {
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ (dataItem[col.field] | date:'MM/dd/yyyy') }}
                </ng-template>
              }
            </kendo-grid-column>
          }
          @case ('AfeApprovalDate') {
            <kendo-grid-column field="AfeApprovalDate" title="Approval Date" [width]="col.params.width" [filterable]="col.params.filterable" [hidden]="col.params.hide" [locked]="col.params.lock" filter="date">
              @if (col.displayField == null; as dataItem) {
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ (dataItem[col.field] | date:'MM/dd/yyyy') }}
                </ng-template>
              }
            </kendo-grid-column>
          }
          @case ('CreatedBy') {
            <kendo-grid-column field="CreatedBy" title="Created By" [width]="col.params.width" [hidden]="col.params.hide" [locked]="col.params.lock">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.CreatedBy }}
              </ng-template>
            </kendo-grid-column>
          }
        }
      } @else {
        <kendo-grid-column [field]="col.field" [title]="col.title" [width]="col.params.width" [filterable]="col.params.filterable" [hidden]="col.params.hide" [locked]="col.params.lock">
          @if (col.displayField == null; as dataItem) {
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ col.params.type === 'date' ?  (dataItem[col.field] | date:'MM/dd/yyyy') : (dataItem[col.field]) }}
            </ng-template>
          }
          @if (col.displayField != null; as dataItem) {
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ col.params.type === 'date' ?  (dataItem[col.displayField] | date:'MM/dd/yyyy') : (dataItem[col.displayField]) }}
            </ng-template>
          }
          @if (col.params && col.params.customFilter) {
            <ng-template kendoGridFilterCellTemplate
              let-column="column"
              let-filter="filter">
              @if (col.params.customFilter === 'multiselect') {
                <app-multicheck-filter
                  [isPrimitive]="true"
                  [field]="column.field"
                  [inFilter]="filter"
                  [data]="this[col.params.data]">
                </app-multicheck-filter>
              }
              @else if (col.params.customFilter === 'employee') {
                <app-employee-filter
                  [inFilter]="filter"
                  [data]="this[col.params.data]"
                  valueField="EmployeeId"
                  [filterField]="col.field">
                </app-employee-filter>
              }
            </ng-template>
          }
        </kendo-grid-column>
      }
    }

    <kendo-grid-excel fileName="Export.xlsx" [fetchData]="allData">
      @for (c of columns(); track c) {
        <kendo-excelexport-column [field]="c.field" [title]="c.title" [hidden]="c.params.hide"></kendo-excelexport-column>
      }
    </kendo-grid-excel>

  </kendo-grid>

  @if (loading) {
    <kendo-loader type="converging-spinner" size="large" class="grid-loading-indicator"></kendo-loader>
  }
</div>